import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbConfig } from '../../shared/shared.interface';

@Injectable({
    providedIn: 'root',
})
export class UiCommonService {
    private breadcrumbSubject: BehaviorSubject<BreadcrumbConfig> =
        new BehaviorSubject<BreadcrumbConfig>({
            titleSmall: '',
            titleLarge: '',
            desc: '',
            image: '',
        });

    breadcrumbSubject$ = this.breadcrumbSubject.asObservable();

    constructor() {}

    updateBreadcrumb(breadcrumbConfig: BreadcrumbConfig): void {
        this.breadcrumbSubject.next({ ...breadcrumbConfig });
    }
}
